import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, set } from 'idb-keyval';
import i18n from 'shared/helpers/i18n';
import TreasuresView from 'shared/constants/treasures-view';

enum SettingsKeys {
  SIDER_STATUS = 'userSettingSiderStatus',
  TREASURES_VIEW = 'userSettingTreasuresView',
  DATE_FORMAT = 'userSettingDateFormat',
}

type UpdateSettingsParams = {
  language?: string;
  dateFormat?: string;
  timezone?: string;
  subscribed?: boolean | null;
  siderStatus?: 'collapsed' | 'open';
  treasuresView?: TreasuresView;
};

export const loadSettings = createAsyncThunk('settings/loadSettings', async () => {
  const language = i18n.resolvedLanguage;
  let siderStatus: undefined | 'collapsed' | 'open';
  let treasuresView: undefined | TreasuresView;
  let dateFormat: undefined | string;

  try {
    siderStatus = await get(SettingsKeys.SIDER_STATUS);
    treasuresView = await get(SettingsKeys.TREASURES_VIEW);
    dateFormat = await get(SettingsKeys.DATE_FORMAT);

    if (!siderStatus) {
      siderStatus = 'open';
      set(SettingsKeys.SIDER_STATUS, 'open');
    }

    if (!treasuresView) {
      treasuresView = TreasuresView.CARD;
      set(SettingsKeys.TREASURES_VIEW, TreasuresView.CARD);
    }
  } catch (err) {
    console.error(err);

    // On Firefox incognito you can't use idb
    if (!siderStatus) {
      siderStatus = 'open';
    }

    if (!treasuresView) {
      treasuresView = TreasuresView.CARD;
    }
  }

  return {
    language,
    dateFormat,
    siderStatus,
    treasuresView,
  };
});

export const updateSettings = createAsyncThunk(
  'settings/updateSettings',
  async ({ language, dateFormat, timezone, subscribed, siderStatus, treasuresView }: UpdateSettingsParams) => {
    if (language != null) {
      i18n.changeLanguage(language);
    }

    dateFormat != null && set(SettingsKeys.DATE_FORMAT, dateFormat);

    siderStatus != null && set(SettingsKeys.SIDER_STATUS, siderStatus);

    treasuresView != null && set(SettingsKeys.TREASURES_VIEW, treasuresView);

    return {
      language,
      dateFormat,
      timezone,
      subscribed,
      siderStatus,
      treasuresView,
    };
  }
);
